import { Routes, Route } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/DashboardPage";
import Layout from "./Components/Layout";
import Profile from "./Pages/Setting/Profile";
import Settings from "./Pages/Setting/SecuritySettings";
import NotFound from "./utils/NotFound";
import Login from "./Pages/Login/Login";
import PublicRoute from "./Route/PublicRoute";
import PrivateRoute from "./Route/PrivateRoute";
import EditProfile from "./Pages/Setting/EditProfile";
import PendingProperty from "./Pages/Properties/pending";
import Notifications from "./Pages/Notifications/Notifications";
import RejectedProperty from "./Pages/Properties/reject";
import Approved from "./Pages/Properties/approve";
import AllContactUs from "./Pages/contactUs/approve";
import AllUsers from "./Pages/Users/Users";
import PropertyQuery from "./Pages/Properties/PeropertyQuery";
import BankListPage from "./Pages/Bank/Loan";
import AddBankPage from "./Pages/Bank/LoanAdd";
import EditBankPage from "./Pages/Bank/LoanEdit";
import PropertyTable from "./Pages/Bank/LoanQuery";
import HomeServices from "./Pages/HomeService/ServiceListing";
import CreateHomeService from "./Pages/HomeService/AddService";
import JobQueries from "./Pages/HomeService/JobsQuery";
import AdminCities from "./Pages/Cities/ListingCity";
import AllocateService from "./Pages/HomeService/AllocateService";
import AllAdmins from "./Pages/Admins/Admins";
import CreateAdmin from "./Pages/Admins/SaveAdmin";
import Sold from "./Pages/Properties/sold";
import UpdatePropertyPage from "./Pages/Properties/EditProperty";
import InactiveProperties from "./Pages/Properties/InactivePrperties";
import ServiceSetting from "./Pages/HomeService/ServiceSetting";
import SubscriptionPage from "./Pages/HomeService/subscription";
import CandidatesListing from "./Pages/careers/careerListing";
import JobListingManager from "./Pages/careers/VacancyCareer";
import MyAgents from "./Pages/HomeService/MyAgents";
import AgentProfile from "./Pages/HomeService/AgentProfile";
import PayoutDetails from "./Pages/HomeService/PayoutDetails";
import AssociatedClients from "./Pages/AssociatedClients";
import AddPropertyPage from "./Pages/Properties/AddProperty";
import PropertyCategories from "./Pages/Properties/PropertyCategories";
import BannerManagement from "./Pages/BannerManagement";
import ServicePaymentHistory from "./Pages/HomeService/ServicePaymentHistory";
import WithdrawalRequests from "./Pages/HomeService/WithdrawalRequests";
import AgentSettlements from "./Pages/HomeService/AgentSettlements";




function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route path="/auth/login" element={<Login />} />
      </Route>
      <Route path="/notifications" element={<Notifications />} />


      {/* Private routes */}

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/settings/security" element={<Settings />} />
          <Route path="/settings/profile/edit" element={<EditProfile />} />
          <Route path="/settings/profile" element={<Profile />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/properties/add" element={<AddPropertyPage />} />
          <Route path="/properties/categories" element={<PropertyCategories />} />
          <Route path="/banners/" element={<BannerManagement />} />

          <Route path="/properties/pending" element={<PendingProperty />} />
          <Route path="/properties/rejected" element={<RejectedProperty />} />
          <Route path="/properties/approved" element={<Approved />} />
          <Route path="/properties/sold" element={<Sold />} />
          <Route path="/properties/inactive" element={<InactiveProperties />} />
          <Route path="/properties/query" element={<PropertyQuery />} />
          <Route path="/properties/edit/:id" element={<UpdatePropertyPage />} />

          <Route path="/contact-us" element={<AllContactUs />} />

          <Route path="/admins" element={<AllAdmins />} />
          <Route path="/save-admin" element={<CreateAdmin />} />

          <Route path="/CandidatesListing" element={<CandidatesListing />} />
          <Route path="/vacancies" element={<JobListingManager />} />

          <Route path="/users" element={<AllUsers />} />
          <Route path="/cities" element={<AdminCities />} />
          <Route path="/associated-clients" element={<AssociatedClients />} />

          <Route path="/loans/listing" element={<BankListPage />} />
          <Route path="/loans/edit" element={<EditBankPage />} />
          <Route path="/loans/queries" element={<PropertyTable />} />
          <Route path="/loans/add-new" element={<AddBankPage />} />

          <Route path="/services/setting" element={<ServiceSetting />} />
          <Route path="/services/category" element={<HomeServices />} />
          <Route path="/services/booking" element={<AllocateService />} />
          <Route path="/services/create" element={<CreateHomeService />} />
          <Route path="/services/Ajent" element={<JobQueries />} />
          <Route path="/services/my-agents" element={<MyAgents />} />
          <Route path="/services/agent-settlements" element={<AgentSettlements />} />
          <Route path="/services/withdrawal-requests" element={<WithdrawalRequests />} />
          <Route path="/services/agent-profile/:id" element={<AgentProfile />} />
          <Route path="/services/payout-details/:id" element={<PayoutDetails />} />
          <Route path="/services/subscription" element={<SubscriptionPage />} />
          <Route path="/services/payment-history" element={<ServicePaymentHistory />} />

        </Route>
      </Route>
    </Routes>
  );
}

export default App;
